<template>

    <a-table :columns="columns" :data-source="baseData">
      <a slot="name" slot-scope="text">{{ text }}</a>
    </a-table>


</template>

<script>
import {dataApi} from "@/services/operate/fissionStatistics.js";


const columns = [
  {
    title: '时间',
    dataIndex: 'dateStr',
    // key: 1,
  },
  {
    title: '参与客户',
    dataIndex: 'joinTodayCount',
    // key: 2,
  },
  {
    title: '新增客户',
    dataIndex: 'addTodayCount',
    // key: 3,
  },
  {
    title: '流失客户',
    dataIndex: 'deleteTodayCount',
    // key: 4,
  },
  {
    title: '获奖客户',
    dataIndex: 'winTodayCount',
    // key: 5,
  },
];

export default {
  name:'tabOneList',
  props:['fissionId'],
  data(){
    return {
      baseData:[],
      columns,
    }
  },
  mounted() {
    dataApi.getBaseDayData(this.fissionId).then((res)=>{
      let resData = res.data;
      resData.forEach(item => {
        let tableItem = {
          // key: index,
          addTodayCount: item.addTodayCount,
          dateStr: item.dateStr,
          deleteTodayCount: item.deleteTodayCount,
          joinTodayCount: item.joinTodayCount,
          winTodayCount: item.winTodayCount,
        }
        this.baseData.push(tableItem)
      })

    }).catch(error => console.log('查询失败', error))

  }
}

</script>

<style lang="less" scoped>

</style>